import * as React from 'react';
import { Button } from './Button';
import { Input } from './Input';
import { getChiefNameSuggestions, findSimilarChiefName } from './ChiefNameInput.logic';
import './ChiefNameInput.css';

interface ChiefNameInputProps {
  id: string;
  className?: string;
  value: string;
  onChange: (name: string) => void;
  // ほかの物件で使われている責任者名
  existingChiefNames: string[];
  validationMessage?: string;
}

/**
 * 物件の責任者名の入力欄。自由に入力でき、打ち始めると既存の責任者名を候補として出す。
 * 入力欄から離れたときに既存の名前と表記だけが違えば知らせ、既存の名前に置き換えられるようにする。保存は止めない
 */
export const ChiefNameInput: React.FC<ChiefNameInputProps> = function (props) {
  const [similarName, setSimilarName] = React.useState<string>();
  const listId = `${props.id}-suggestions`;

  return (
    <div className="ChiefNameInput-container">
      <Input
        id={props.id}
        className={props.className}
        type="string"
        required={true}
        list={listId}
        value={props.value}
        validationMessage={props.validationMessage}
        onChange={event => {
          props.onChange(event.target.value);
          setSimilarName(undefined);
        }}
        onBlur={() => setSimilarName(findSimilarChiefName(props.value, props.existingChiefNames))}
      />
      <datalist id={listId}>
        {getChiefNameSuggestions(props.existingChiefNames).map(name => (
          <option key={name} value={name} />
        ))}
      </datalist>
      {similarName !== undefined && (
        <div className="ChiefNameInput-message">
          <span>既存の責任者「{similarName}」と表記だけが違う名前です</span>
          <Button
            mini
            color="white"
            onClick={() => {
              props.onChange(similarName);
              setSimilarName(undefined);
            }}
          >
            既存の「{similarName}」を使う
          </Button>
        </div>
      )}
    </div>
  );
};
